export default (function (element) {
  var rect = JSON.parse(JSON.stringify(element.getBoundingClientRect()));
  rect.x = rect.left;
  rect.y = rect.top;
  return rect;
});